export default __webpack_public_path__ + "static/Unionget2-ee7660f48636107777fc1b503129fd58.png";